import marketplacePropertiesService from '../MarketplacePropertiesService';
import constants from '../../qti/Constants';
import { t } from '../i18nService';

const InlineChoiceService = {
    isA11yIterationForInlineChoiceEnabled() {
        return marketplacePropertiesService.getA11yIterationForInlineChoiceValue() >= 1;
    },

    getInlineChoiceSelectAriaLabelCaption(inlineChoiceModel, responseModels) {
        if (responseModels && inlineChoiceModel) {
            const positionOfInlineChoiceInInteraction = this.getPositionOfInlineChoiceInInteraction(inlineChoiceModel.identifier, responseModels);
            if (positionOfInlineChoiceInInteraction !== -1) {
                return t('interactions.inlineChoice.fieldAriaLabel', { positionNumber: positionOfInlineChoiceInInteraction + 1 });
            }
        }
        return null;
    },

    getPositionOfInlineChoiceInInteraction(identifier, responseModels) {
        const inlineChoiceResponseModels = responseModels.filter(response => response.type === constants.interactionType.INLINE_CHOICE_INTERACTION);
        return inlineChoiceResponseModels.findIndex(response => response.identifier === identifier);
    },
};

export default InlineChoiceService;
